import { Component, inject } from '@angular/core';
import { UserOidToNamePipe } from '../../pipes/user-oid-to-name.pipe';

@Component({
  standalone: false,
  selector: 'ag-grid-user-renderer',
  template: `{{ renderedValue }}`,
})
export class AgGridUserRendererComponent {
  renderedValue: string = '';

  private userOidToNamePipe = inject(UserOidToNamePipe);

  agInit(params: any): void {
    const oid = params.value;
    this.userOidToNamePipe.transform(oid).subscribe((value) => {
      this.renderedValue = value;
    });
  }

  refresh(): boolean {
    return false;
  }
}
